import { injectable } from "tsyringe";
import { ManageConfigInjection } from "../../di/ManageConfigInjection";
import { ManageConfigFormRequestEntity } from "../entities/ManageConfigFormRequestEntity";
import { ManageConfigListRequestEntity } from "../entities/ManageConfigListRequestEntity";

@injectable()
export class ManageConfigUseCase {
  private repo = ManageConfigInjection.getRepo();

  private checkParams(params: ManageConfigListRequestEntity) {
    const { page = 0, limit = 10, ...rest } = params;
    return { page, limit, ...rest };
  }

  async getManageConfigList(params: ManageConfigListRequestEntity) {
    return this.repo.getList(this.checkParams(params));
  }

  async getManageConfigDetail(code: string) {
    return this.repo.getDetail({ code });
  }

  async createManageConfig(body: ManageConfigFormRequestEntity) {
    return this.repo.create(body);
  }

  async updateManageConfig(body: ManageConfigFormRequestEntity) {
    return this.repo.update(body);
  }

  async deleteManageConfig(code: string) {
    return this.repo.delete({ code });
  }
}
